// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1b_qN","col":"styles_col__3UWNh"};